// extracted by mini-css-extract-plugin
module.exports = {"foolScreen":"NewFoolScreen_foolScreen__2x_Yh","subscribersBlock":"NewFoolScreen_subscribersBlock__3NMFJ"};